import type { BasicCustomerFragment, CompleteBookingFragment } from '@drycut/graphql';

import { Para, Stack } from '@drycut/ui-components';
import { MinusIcon, StarIcon } from '@heroicons/react/20/solid';

import { NO_PHONE_NUMBER } from '../constants';
import { CustomerBookingIcons } from '../CustomerBookingIcons';
import PreferencesPopover from './PreferencesPopover';

type Props = {
  booking?: CompleteBookingFragment;
  customer?: BasicCustomerFragment | null;
};

export function CustomerBox({ booking, customer }: Props): React.ReactElement {
  const computedCustomerName = booking?.customName || customer?.name;
  const bookingsCount = customer?.bookingsCount || 0;
  const isNoPhoneCustomer = customer?.phoneNumber === NO_PHONE_NUMBER;

  // We want to show the number of cuts only if the customer has one cut and then every 5 cuts
  // (5, 10, 15, 20, etc.)
  const showCutsCount =
    (bookingsCount === 1 || bookingsCount % 5 === 0) && bookingsCount > 0 && !isNoPhoneCustomer;

  return (
    <PreferencesPopover customer={customer}>
      <Stack className="relative p-2 bg-white w-full items-center justify-center min-h-20">
        {showCutsCount && (
          <Stack className="absolute text-center top-0 left-0">
            <StarIcon className="w-12 h-12  absolute -top-5 -left-2 fill-amber-400" />
            <Para weight="bold" size="sm" className="absolute text-white -left-2 -top-1 w-12">
              {bookingsCount}
            </Para>
          </Stack>
        )}

        <Para weight="bold" className="mb-1">
          {computedCustomerName || <MinusIcon className="w-6 h-6 opacity-40" />}
        </Para>

        {booking && customer && <CustomerBookingIcons booking={booking} customer={customer} />}
      </Stack>
    </PreferencesPopover>
  );
}
